/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Clients_Score_IntentInputs */

const cs_clients_score_intent = /** @type {(inputs: Clients_Score_IntentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zájem ${i?.n}`)
};

const en_clients_score_intent = /** @type {(inputs: Clients_Score_IntentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Intent ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Intent {n}" |
*
* @param {Clients_Score_IntentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_score_intent = /** @type {((inputs: Clients_Score_IntentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Score_IntentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_score_intent(inputs)
	return cs_clients_score_intent(inputs)
});